import { Text /* , getColorInRange */ } from '@innovationdepartment/proxima-ui';
import type { BrandProductCellRendererComponentProps } from '../types';

// const colorValues = [
//   [5, 70, 71], // red / low
//   [35, 69, 81], // orange / medium
//   [136, 50, 59], // green / high
// ];

const BrandProductsClassificationScore = (
  props: BrandProductCellRendererComponentProps<'classificationScore'>
) => {
  const { value } = props;

  // const percentage = +value * 100;
  // const color = getColorInRange(+percentage, colorValues).rgb;

  return (
    <Text color="green40" variant="table1">
      {/* <span style={{ color, fontWeight: 'bolder' }}> */}
      {(+value).toFixed(3)}
      {/* </span> */}
    </Text>
  );
};

export default BrandProductsClassificationScore;
